export default __webpack_public_path__ + "static/media/room_2.4f74a6b6.png";